import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export const FloatingQR = () => {
  const navigate = useNavigate();

  const handleQRScanClick = () => {
    navigate('/qr-scan');
  };

  return (
    <div className="fixed bottom-24 right-6 md:bottom-6 z-50">
      {/* Main QR Scanner FAB */}
      <Button
        variant="accent"
        size="lg"
        className="rounded-full w-16 h-16 shadow-elevation-3 hover:scale-105 scan-frame no-zoom touch-target"
        onClick={handleQRScanClick}
        title="QR Kod Tara"
      >
        <Plus className="w-6 h-6" />
      </Button>
    </div>
  );
};